<template>
  <app-page-container extra>
    <app-form-group label="Reservation notes" label-for="reservation_notes">
      <app-textarea
        @change.native="onPatchReservationNotes"
        v-model="mealData.reservation_notes"
        rows="5"
        placeholder="Write a note"
        id="reservation_notes"
      />
    </app-form-group>
  </app-page-container>
</template>

<script>
import { patchReservationsMeal } from '@/http'

export default {
  name: 'ReservationMealGeneral',
  props: {
    mealData: Object,
  },
  methods: {
    onPatchReservationNotes() {
      patchReservationsMeal(this.$route.params.id, { reservation_notes: this.mealData.reservation_notes })
    },
  }
}
</script>
